import React from 'react';

export const PMIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M2 12 C4 6, 6 6, 8 12 S 10 18, 12 12 C 14 18, 16 18, 18 12 S 20 6, 22 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <line x1="12" y1="4" x2="12" y2="20" stroke="currentColor" strokeWidth="1.5" strokeDasharray="2 2" />
  </svg>
);